import { gql } from "@apollo/client";

export const QUERY_USING_AKS_WEATHER = gql`
  query getUsingAKSWeather {
    getUsingAKSWeather
  }
`;

export const QUERY_MOST_RECENT_FRAMES = gql`
  query getMostRecentFrames($tStart: Float, $tEnd: Float) {
    getMostRecentFrames(tStart: $tStart, tEnd: $tEnd) {
      frameType0 {
        dt
        SN
        RSSI
        srPos
        carId
        pwrMode
        pAbs
        VBat
        pctBat
      }
      frameType1 {
        dt
        SN
        TAir
        RH
        TIR2
        TIR3
        TIR4
      }
    }
  }
`;

export const QUERY_TPMS_FRAME_DATA = gql`
  query getTPMSFrameData($tStart: Float, $tEnd: Float) {
    getTPMSFrameData(tStart: $tStart, tEnd: $tEnd) {
      frameType0 {
        dt
        SN
        pAbs
      }
      frameType1 {
        dt
        SN
        TAir
        TIR2
        TIR3
        TIR4
      }
    }
  }
`;

export const QUERY_TPMS_CONFIG = gql`
  query getTPMSConfig {
    getTPMSConfig {
      tyres {
        carId
        tyreId
        sensorId
        isFront
      }
      pAtm
      pWarning
      tAmbient
      tGarage
      kHeatTransferAir
      kHeatTransferTyre
    }
  }
`;

export const QUERY_TPMS_RECEIVER_STATE = gql`
  query getTPMSReceiverState {
    getTPMSReceiverState
  }
`;

export const SUBSCRIBE_USING_AKS_WEATHER_UPDATE = gql`
  subscription newUsingAKSWeatherUpdate {
    newUsingAKSWeatherUpdate
  }
`;

export const SUBSCRIBE_TPMS_CONFIG = gql`
  subscription newTPMSConfig {
    newTPMSConfig {
      tyres {
        carId
        sensorId
        tyreId
        isFront
      }
      pAtm
      pWarning
      tAmbient
      tGarage
      kHeatTransferAir
      kHeatTransferTyre
    }
  }
`;

export const SUBSCRIBE_TPMS_BATCH_FRAMES = gql`
  subscription newTPMSBatchFrames {
    newTPMSBatchFrames {
      frameType0 {
        dt
        frameType
        SN
        RSSI
        #NTX
        #srType
        srPos
        #tyreType
        #teamId
        carId
        pwrMode
        #dxs
        #TBoard
        pAbs
        VBat
        pctBat
      }
      frameType1 {
        dt
        frameType
        SN
        #NTX
        TAir
        RH
        #TRim
        #TIR1
        TIR2
        TIR3
        TIR4
        #TIR5
      }
    }
  }
`;

export const SUBSCRIBE_TPMS_FRAME_TYPE_0 = gql`
  subscription newTPMSFrameType0 {
    newTPMSFrameType0 {
      dt
      SN
      RSSI
      #NTX
      #srType
      srPos
      #tyreType
      #teamId
      carId
      pwrMode
      #dxs
      #TBoard
      pAbs
      VBat
      pctBat
    }
  }
`;

export const SUBSCRIBE_TPMS_FRAME_TYPE_1 = gql`
  subscription newTPMSFrameType1 {
    newTPMSFrameType1 {
      dt
      SN
      #NTX
      TAir
      RH
      #TRim
      #TIR1
      TIR2
      TIR3
      TIR4
      #TIR5
    }
  }
`;

export const SUBSCRIBE_TPMS_RECEIVER_STATE = gql`
  subscription newTPMSReceiverState {
    newTPMSReceiverState
  }
`;

export const MUTATE_TPMS_CONFIG = gql`
  mutation updateTPMSConfig(
    $tyres: [TyreConfigInput!]
    $pAtm: Float
    $pWarning: Float
    $tAmbient: Float
    $tGarage: Float
    $kHeatTransferAir: Float
    $kHeatTransferTyre: Float
  ) {
    updateTPMSConfig(
      tyres: $tyres
      pAtm: $pAtm
      pWarning: $pWarning
      tAmbient: $tAmbient
      tGarage: $tGarage
      kHeatTransferAir: $kHeatTransferAir
      kHeatTransferTyre: $kHeatTransferTyre
    )
  }
`;

export const QUERY_STINTS = gql`
  query getStints($eventCode: String!, $carNum: String!) {
    getStints(eventCode: $eventCode, carNum: $carNum) {
      dt
      carNum
      stints {
        type
        openLapNumber
        closeLapNumber
        lapsInStint
        startTime
        finishTime
        sesId
        sessionName
        tpmsAtStart {
          dt
          frontLeft
          frontRight
          rearLeft
          rearRight
        }
      }
    }
  }
`;

export const QUERY_TYRE_LAP_TOTALS = gql`
  query getTyreLapTotals($eventCode: String!, $carNum: String!) {
    getTyreLapTotals(eventCode: $eventCode, carNum: $carNum) {
      id
      laps
    }
  }
`;

export const QUERY_UNIQUE_EVENTS = gql`
  query getFIAEvents {
    getFIAEvents {
      eventCode
      location
      startDate
      endDate
      guid
    }
  }
`;

export const QUERY_REAL_SESSIONS_FOR_EVENT = gql`
  query getRealSessionsForEvent($eventCode: String!) {
    getRealSessionsForEvent(eventCode: $eventCode) {
      _id
      session
      dt
    }
  }
`;

export const QUERY_DRIVER_NAMES = gql`
  query GetDriverNamesForEvent($eventCode: String!) {
    getDriverNamesForEvent(eventCode: $eventCode) {
      carNum
      name
      team
      color
    }
  }
`;

export const QUERY_STINTS_WITH_TPMS_FOR_ALL_CARS = gql`
  query getStintsWithTPMSForAllCars($eventCode: String!) {
    getStintsWithTPMSForAllCars(eventCode: $eventCode) {
      dt
      carNum
      stints {
        type
        sesId
        lapsInStint
        closeLapNumber
        openLapNumber
        startTime
        finishTime
        sessionName
        tpmsAtStart {
          dt
          frontLeft
          frontRight
          rearLeft
          rearRight
        }
      }
      pitIns {
        lapNumber
        time
        dayTime
        driver
        transponderCode
        transponderIndex
        sesId
      }
    }
  }
`;

export const QUERY_STINTS_WITH_TPMS_FOR_CAR = gql`
  query getStintsWithTPMSForCar($eventCode: String!, $carNum: String!) {
    getStintsWithTPMSForCar(eventCode: $eventCode, carNum: $carNum) {
      dt
      carNum
      stints {
        type
        sesId
        lapsInStint
        closeLapNumber
        openLapNumber
        startTime
        finishTime
        sessionName
        tpmsAtStart {
          dt
          frontLeft
          frontRight
          rearLeft
          rearRight
        }
      }
      pitIns {
        lapNumber
        time
        dayTime
        driver
        transponderCode
        transponderIndex
        sesId
      }
    }
  }
`;

export const QUERY_SESSION_DISPLAY_NAME_MAP = gql`
  query getSessionDisplayNameMap($sessionIds: [String!]!) {
    getSessionDisplayNameMap(sessionIds: $sessionIds) {
      displayName
      aksSessionId
    }
  }
`;

export const QUERY_TRACK_LENGTH = gql`
  query getTrackLength($eventCode: String!) {
    getTrackLength(eventCode: $eventCode)
  }
`;

export const MUTATE_TRACK_LENGTH = gql`
  mutation setTrackLength($eventCode: String!, $trackLengthKm: Float!) {
    setTrackLength(eventCode: $eventCode, trackLengthKm: $trackLengthKm)
  }
`;

export const MUTATE_CLEAR_TPMS_EVENT_CACHE = gql`
  mutation clearTPMSEventCache($eventCode: String!) {
    clearTPMSEventCache(eventCode: $eventCode) {
      eventCode
      deletedCount
    }
  }
`;

export const QUERY_SESSION_IDS_FOR_EVENT = gql`
  query getSessionIdsForEvent($eventCode: String!) {
    getSessionIdsForEvent(eventCode: $eventCode)
  }
`;

export const QUERY_CAR_STATUS = gql`
  query carStatus($eventCode: String!) {
    carStatus(eventCode: $eventCode) {
      carNum
      status
      sessionId
      tpms {
        frontLeft
        frontRight
        rearLeft
        rearRight
      }
    }
  }
`;

export const MUTATE_USING_AKS_WEATHER = gql`
  mutation setUsingAKSWeather($usingAKSWeather: Boolean!) {
    setUsingAKSWeather(usingAKSWeather: $usingAKSWeather)
  }
`;

export const MUTATE_SET_SELECTED_TYRES = gql`
  mutation setSelectedTyres($tyreIds: [String!]!) {
    setSelectedTyres(tyreIds: $tyreIds)
  }
`;

export const GET_RECENT_TYRE_SNAPSHOTS = gql`
  query GetRecentTyreSnapshots {
    getRecentTyreSnapshots {
      _id
      ts
      tyreIds
      frames
    }
  }
`;
